module.exports = __webpack_public_path__ + "static/media/icon_users@2x.96360647.png";